import React from "react"
import Layout from "../../../components/Layout"
import data from "../../../data"

export default function index() {
  return (
    <Layout>
      <div className="section">
        <div className="section-heading">
          <br />
          <p>{data.sideBar.dataset.title}</p>
          <h1>{data.sideBar.dataset.links[2]}</h1>
          <br />
        </div>
      </div>
    </Layout>
  )
}
